export { default } from './ExternalChannelBadge';
